import React from 'react';
import Slider from 'react-slick';
import cx from 'classnames';

import * as styles from './custom-slider.module.scss';

const defaultSettings = {
  autoplay: true,
  speed: 305,
  dots: true,
};

export const CustomSlider = ({
  sliderRef,
  handleBeforeChange,
  handleAfterChange,
  children,
  settings = {},
  className,
  dark = false,
}) => {
  const sliderSettings = { ...defaultSettings, ...settings };

  return (
    <div
      className={cx(styles[className] || styles.slider, {
        [styles.darkMode]: dark,
      })}
    >
      <Slider
        ref={sliderRef}
        beforeChange={handleBeforeChange}
        afterChange={handleAfterChange}
        {...sliderSettings}
        className="slick-slider slick-dotted"
      >
        {children}
      </Slider>
    </div>
  );
};
